import { isTestingEnv } from '@/shared/lib/internal/utility';
import { scriptsByEnvironment } from '../constants';
import { venueDataAccessor } from '@stores/webStorages/storages/VenueData.accessor.ts';
import type { ScriptTuple } from '@features/third-party-scripts/types/ScriptTuple.ts';

export const insertThirdPartyScripts = () => {
  const venueData = venueDataAccessor.getVenueData();
  const getScripts = isTestingEnv() ? scriptsByEnvironment.uat : scriptsByEnvironment.production;
  const scripts = getScripts(venueData);

  const filteredScripts = scripts.filter((s) => s) as ScriptTuple[];

  filteredScripts.forEach(({ position, target, scriptMarkup }) => {
    const targetElement = document.getElementsByTagName(target)[0];
    if (!targetElement) return;

    const fragment = document.createRange().createContextualFragment(scriptMarkup);

    if (position === 'append') {
      targetElement.append(fragment);
    } else if (position === 'prepend') {
      targetElement.prepend(fragment);
    }
  });
};
